// Chip del tipo de producto: un color por tipo, el mismo en Inventario y en el Catálogo del vendedor.
import { cn } from '@/lib/cn';
import { segmentToneClass, type SegmentColorSlot } from '@/shared/patterns/Pills/segmentColors';
import { PRODUCT_KIND_LABEL, type ProductKind } from './productKind';

/** Slot de la paleta de segmentos que le toca a cada tipo. */
const KIND_COLOR_SLOT: Record<ProductKind, SegmentColorSlot> = {
    PHONE: 'sky',
    SIM_MODEM: 'emerald',
    ACCESSORY: 'violet',
    KIT: 'teal',
    SERVICE: 'pink',
    CARD: 'amber',
    PREPAID: 'rose',
};

export function KindChip({ kind }: { kind: ProductKind }) {
    return (
        <span
            className={cn(
                'inline-flex items-center whitespace-nowrap rounded-full border px-1.5 py-px text-[9.5px] font-semibold',
                segmentToneClass(KIND_COLOR_SLOT[kind]),
            )}
        >
            {PRODUCT_KIND_LABEL[kind]}
        </span>
    );
}
